<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-actions v-if="currentDraft.questions[questionIdProp]">

    <f7-actions-group>
      <f7-actions-label>修改選項種類: {{ currentDraft.questions[questionIdProp].title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button @click="updateQuestionType(questionType.radioQuestion)">
        {{ $t(`questionType.${questionType.radioQuestion}`) }}
      </f7-actions-button>
      <!-- <f7-actions-button>
        {{ $t(`questionType.${questionType.checkboxQuestion}`) }} (尚未完成)
      </f7-actions-button> -->
      <f7-actions-button @click="updateQuestionType(questionType.switchQuestion)">
        {{ $t(`questionType.${questionType.switchQuestion}`) }}
      </f7-actions-button>
      <!-- <f7-actions-button>
        {{ $t(`questionType.${questionType.numberQuestion}`) }} (尚未完成)
      </f7-actions-button> -->
      <f7-actions-button @click="updateQuestionType(questionType.numberGroupQuestion)">
        {{ $t(`questionType.${questionType.numberGroupQuestion}`) }}
      </f7-actions-button>
    </f7-actions-group>

    <f7-actions-group>
      <f7-actions-button color="red" bold>取消</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ChangeQuestionTypeActionSheet',
  dependencies: ['questionType'],
  data () {
    return {
      pathLength: 0
    }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String,
    questionIdProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft', 'currentElementPath']),
    elementLevel () { return this.pathLength === 6 ? 5 : 3 }
  },
  created () {
    this.pathLength = this.currentElementPath.length
  },
  methods: {
    ...mapActions('menuDraftModule', ['setQuestionProperties']),
    updateQuestionType (type) {
      this.setQuestionProperties({ questionId: this.questionIdProp, elementLevel: this.elementLevel, properties: { type, options: [] } })
    }
  }
}
</script>
